import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Context } from '@nuxt/types/app'
Vue.use(VueI18n)

export enum LangMap {
  en = 'en',
  ja = 'ja',
  ko = 'ko',
  'zh-TW' = 'zh-TW', // 香港繁体中文
  'zh-TW2' = 'zh-TW2', // 台湾繁体中文
  'zh-MO' = 'zh-MO', // 澳门繁体中文
  'zh-SG' = 'zh-SG', // 马来西亚
  'zh-MY' = 'zh-MY' // 马来西亚
}
export enum AreaMap {
  HK = 'HK',
  US = 'US',
  JP = 'JP',
  KR = 'KR',
  TW = 'TW',
  MO = 'MO',
  SG = 'SG',
  MY = 'MY'
}

export default (
  { app, store, query: { lang, area, activityId } } = <Context>{}
) => {
  if (process.server) {
    console.log('服务端获取页面入参lang: ', lang)
    console.log('服务端获取页面入参area: ', area)
  }

  if (process.client) {
    const Cookies = require('js-cookie')
    lang = Cookies.get('locale') || lang

    // if (lang === 'zh' && !activityId) {
    //   lang = 'zh-TW'
    // }

    area = Cookies.get('region') || area
  }
  lang && store.commit('UP_LANG', lang)
  area && store.commit('UP_AREA', area)
  const defaultConfig = {
    locale: lang || LangMap.en, // 设置语言环境
    fallbackLocale: LangMap.en
  }
  const createI18n = (config = {}) => {
    const i18n = new VueI18n({ ...(defaultConfig as any), ...config })
    return i18n
  }
  app.i18n = createI18n()
  app.createI18n = createI18n
}
